import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';
import {
  RELIGION_CHAOS_LEVELS,
  RELIGION_ZEALS,
  CONVERT_PRESSURES
} from '../../../constants/religion.constants';

interface ReligionEntry {
  azgaarId?: number;
  name: string;
  zeal: string;
  convertPressure: string;
  notes: string;
}

@Component({
    selector: 'app-religions-step',
    templateUrl: './religions-step.component.html',
    styleUrls: ['./religions-step.component.scss'],
    standalone: false
})
export class ReligionsStepComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  chaosLevels = RELIGION_CHAOS_LEVELS;
  zeals = RELIGION_ZEALS;
  pressures = CONVERT_PRESSURES;

  mapName = '';
  religionChaosLevel = '';
  religionsList: ReligionEntry[] = [];

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';
      this.religionChaosLevel = state.religionChaosLevel || '';

      // Initialize religions from state, mapping prefilled data
      if (state.religions && state.religions.length > 0) {
        this.religionsList = state.religions.map((r: any) => ({
          azgaarId: r.azgaarId || r.azgaar_id,
          name: r.name,
          zeal: r.zeal || '',
          convertPressure: r.convertPressure || r.conversionPressure || '',
          notes: r.notes || ''
        }));
      } else {
        let extractedReligions: ReligionEntry[] = [];
        if (state.mapJson) {
          const json = state.mapJson;
          const rawReligions = json.religions || json.pack?.religions || [];
          extractedReligions = rawReligions
            .filter((r: any) => r && r.name && r.name !== 'No religion' && r.name.toLowerCase() !== 'none' && r.name !== 'Neutral')
            .map((r: any) => ({
              azgaarId: r.i,
              name: r.name,
              zeal: '',
              convertPressure: '',
              notes: ''
            }));
        }

        if (extractedReligions.length > 0) {
          this.religionsList = extractedReligions;
        } else {
          this.religionsList = [
            { azgaarId: 1, name: 'Religion1', zeal: '', convertPressure: '', notes: '' },
            { azgaarId: 2, name: 'Religion2', zeal: '', convertPressure: '', notes: '' },
            { azgaarId: 3, name: 'Religion3', zeal: '', convertPressure: '', notes: '' }
          ];
        }
      }
      this.cdr.detectChanges();
    });
  }

  saveState(): void {
    this.stateService.updateState({
      religionChaosLevel: this.religionChaosLevel,
      religions: this.religionsList
    });
  }

  onNext(): void {
    this.saveState();
    this.next.emit();
  }

  onBack(): void {
    this.saveState();
    this.back.emit();
  }
}
